import { request } from "../../../../services/api.ts"
import { PerformanceLoadError } from "../api"
import type { ComparisonQuery, ComparisonResponse } from "./types"

export const COMPARISON_PATH = "/dashboard/team-performance/comparison/"

export const comparisonParams = ({
  grain,
  to,
  memberIds
}: ComparisonQuery) => ({
  grain,
  ...(to ? { to } : {}),
  ...(memberIds.length ? { members: memberIds.join(",") } : {})
})

export const fetchComparison = async (
  query: ComparisonQuery
): Promise<ComparisonResponse> => {
  const response = await request.api.get<ComparisonResponse>(
    COMPARISON_PATH,
    comparisonParams(query)
  )
  if (!response.ok || !response.data)
    throw new PerformanceLoadError(response.status)
  return response.data
}
